<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="$t('clientes.clientes')" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <r-dynamic-list
        v-if="!popupClientesDuplicadosOpened"
        ref="rlist"
        :dbAdapter="Cliente"
        :tableCode="'CLIENTE'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="true"
        :controlsWidth="120"
        :shown-fields="['codigo', 'bcId']"
        :descartar-respuestas-obsoletas="true"
        @load="cargarRecuentoGestionCobro"
        @clear-data="olvidarRecuentoGestionCobro"
      >
        <template v-slot:tableLinks>
          <r-badge
            v-if="textoRecuentoGestionCobro"
            class="badge-sin-responsable-cobro"
            :color="recuentoGestionCobro && recuentoGestionCobro.mostradosSinResponsable ? 'red' : 'green'"
            :text="textoRecuentoGestionCobro"
            v-tooltip="'Clientes sin responsable de gestión de cobro. Sus facturas nuevas nacen sin gestor.'"
          ></r-badge>
          <r-form
            cass="form-inline"
            ref="rformImport"
            v-slot="{rform}"
            :readonly="false"
            :dbAdapter="null"
            :documentoAdapter="Documento"
            :beforeSave="beforeSaveImport"
            :hidePreloaderOnSave="false"
            @save="onImport"
            @error="onImportError"
          >
            <r-files
              path="/importacion-clientes/"
              :conservarNombre="true"
              :sobrescribir="true"
              :form="rform"
              name="documento"
              :maxFiles='1'
              label="Importar Clientes"
              @loadFile="loadFile"
              :preview="false"
            ></r-files>
            <div class="nuevo_cliente"><a class="link" href="/clientes/new/">Nuevo cliente</a></div>
          </r-form>
        </template>
        <template v-slot:extendedActions>
          <f7-link icon-f7="person_2_square_stack_fill" color="red" @click="popupClientesDuplicadosEditable = true; popupClientesDuplicadosOpened = true" v-tooltip="'Buscar Duplicados'"></f7-link>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link icon-f7="eye" color="green" :href="`/clientes/view/${item.id}/`" v-tooltip="'Ver Cliente'"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/clientes/edit/${item.id}/`" v-tooltip="'Editar Cliente'"></f7-link>
          <!-- Abrir popup facturas -->
          <f7-link icon-f7="doc_plaintext" color="red" @click="mostrarFacturas(item.codigo)" v-tooltip="'Ver Facturas'"></f7-link>
          <f7-link v-if="item.bcId" v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.verEnBC')" icon-f7="link" color="orange" @click="verEnBC(item.bcId)"></f7-link>
          <f7-link v-roles="['ADMIN', 'ADMINISTRACION']" v-tooltip="$t('pedidos.enviarBC')" icon-f7="arrow_up_circle" color="purple" @click="enviarBC(item.id)"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>

    <f7-popup ref="popupClientesDuplicados" :tablet-fullscreen="true" :opened="true" v-if="popupClientesDuplicadosOpened" @popup:closed="popupClientesDuplicadosOpened = false;" swipe-to-close>
      <f7-navbar>
        <!-- <f7-nav-left>
          <f7-link @click="applyChanges">Guardar</f7-link>
        </f7-nav-left> -->
        <f7-nav-title>Clientes duplicados</f7-nav-title>
        <f7-nav-right></f7-nav-right>
			</f7-navbar>
      <clientes-duplicados 
        @close="$refs.popupClientesDuplicados.close();"
        :defaultData="{}" 
        :esPopup="true"
        :popupObject="$refs.popupClientesDuplicados"
      ></clientes-duplicados>
    </f7-popup>
    <f7-popup tablet-fullscreen ref="popupListadoFacturas" class="popup-listado-facturas" :opened="popupListadoFacturasOpened" v-if="popupListadoFacturasOpened && codigoClienteParaFacturas" @popup:closed="popupListadoFacturasOpened = false; codigoClienteParaFacturas = null; " swipe-to-close>
      <Facturas :search-on-init="true" :is-popup="true" :shown-fields="['cliente.codigo']" :mandatory-filter="{ 'cliente##codigo': codigoClienteParaFacturas }" :ignore-table-filters="true"/>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
  .nuevo_cliente {
    text-align: center;
    /* background-color: greenyellow; */
    border-radius: 5px;
    margin: 1px 16px;
    padding: 4px;
  }
  .nuevo_cliente:hover {
    background-color: greenyellow;
    border-radius: 5px;
    margin: 1px 16px;
    padding: 4px;
  }
  .buscar_duplicados {
    text-align: center;
    /* background-color: greenyellow; */
    border-radius: 5px;
    margin: 1px 16px;
    padding: 4px;
  }
  .buscar_duplicados:hover {
    background-color: red;
    border-radius: 5px;
    margin: 1px 16px;
    padding: 4px;
  }
  .badge-sin-responsable-cobro {
    margin: 1px 8px;
  }
</style>
<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import rBadge from "./../../components/rBadge.vue";
import Utils from "./../../js/Utils.js";
import Cliente from "../../js/db/Cliente.js";
import rForm from "../../components/rForm.vue";
import rFiles from "../../components/rFiles.vue";
import ClientesDuplicados from "./componets/clientes-duplicados.vue";
import Documento from "../../js/db/Documento.js";
import Facturas from "../facturas/facturas.vue";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
export default {
  components: {
    rDynamicList,
    rBadge,
    rForm,
    rFiles,
    ClientesDuplicados,
    Facturas,
  },
  data() {
    return {
      Cliente,
      Utils,
      Documento,
      popupClientesDuplicadosOpened: false,
      popupClientesDuplicadosEditable: false,
      popupListadoFacturasOpened: false,
      codigoClienteParaFacturas: null,
      recuentoGestionCobro: null,
      // Qué petición de recuento es la vigente: solo la última manda (ver más abajo).
      generacionRecuento: 0,
    };
  },
  computed: {
    // «12 sin responsable de cobro de los 48 mostrados · 311 en total».
    //
    // La etiqueta dice SIEMPRE «de los N mostrados», con filtros o sin ellos: el número es el del
    // conjunto que la consulta tiene delante, y es lo que pidió dirección para que nadie vea un 4
    // filtrado por una provincia y dé por resuelto lo que no lo está. El total de los activos se
    // añade cuando el backend lo manda; si no, la frase se entiende igual.
    textoRecuentoGestionCobro() {
      const r = this.recuentoGestionCobro;
      if (!r) {
        return null;
      }
      let texto = `${r.mostradosSinResponsable} sin responsable de cobro de los ${r.mostrados} mostrados`;
      if (r.activosSinResponsable != null) {
        texto += ` · ${r.activosSinResponsable} en total`;
      }
      return texto;
    },
  },
  methods: {
    // La tabla se ha vaciado: el número que hay en pantalla era de las filas que ya no están, así
    // que se retira en vez de dejarlo acompañando a una tabla en blanco. Pasa cuando una búsqueda
    // falla —la tabla se vacía antes de pedir y el error no emite `load`, así que sin esto la
    // etiqueta se quedaba con las cifras del filtro anterior para siempre—, al cambiar las columnas
    // visibles, y cuando el `v-if` del popup de duplicados destruye la tabla y monta otra.
    //
    // Subir la generación es parte del arreglo: así el recuento que siguiera en el aire del filtro
    // anterior tampoco puede aterrizar después y volver a poner un número que ya no corresponde.
    //
    // También se llama a mano desde `onImport`: ahí las filas siguen en su sitio, pero los datos que
    // el número resumía han cambiado bajo ellas (ver el comentario de allí).
    olvidarRecuentoGestionCobro() {
      const self = this;
      self.generacionRecuento += 1;
      self.recuentoGestionCobro = null;
    },
    // El recuento se pide tras cada carga de la tabla, con EL FILTRO Y LA PROYECCIÓN QUE VIENEN EN
    // EL EVENTO: los que la tabla capturó al lanzar la consulta que ha traído las filas que hay
    // delante. Así el número baja al asignar (el cambio masivo recarga) y acompaña a cada cambio de
    // filtro.
    //
    // Lo que NO se hace es volver a leer las condiciones de la pantalla al recibir `load`. Si
    // alguien cambia el filtro mientras la búsqueda anterior sigue cargando, al llegar esa
    // respuesta las condiciones ya son las de la búsqueda nueva, y recontar con ellas ponía el
    // número de un conjunto distinto al que se estaba viendo.
    //
    // Pero el contexto en el evento no basta por sí solo, y eso es lo que faltaba: la respuesta
    // vieja no sustituía las filas, se CONCATENABA en la tabla, así que la pantalla acababa con la
    // unión de dos búsquedas y el recuento de una. La otra mitad está en la tabla, encendida desde
    // aquí con `descartar-respuestas-obsoletas`: una respuesta de una búsqueda ya sustituida no
    // toca las filas ni emite `load`. Así que cada `load` que llega aquí es de la consulta que ha
    // traído las filas que hay delante, y sus páginas de scroll infinito también.
    //
    // Solo en la primera página: `load` lo emite también el scroll infinito, y el recuento no
    // depende de cuántas filas se hayan traído, sino del filtro — recontarlo por cada tramo serían
    // consultas de más para el mismo número.
    //
    // Y la primera página la dice el evento, no `rlist.page`: cuando un filtro no devuelve ninguna
    // fila, `getRemoteData` decrementa la página de 1 a 0 antes de avisar, así que mirar `page`
    // dejaba sin recontar justo el caso en el que la tabla se queda vacía — y la etiqueta se
    // quedaba enseñando el número del filtro anterior, que es el engaño que esto venía a evitar.
    cargarRecuentoGestionCobro(consulta) {
      const self = this;
      // Sin el contexto de la consulta no hay a qué conjunto atribuir el número, y un número que no
      // se puede atribuir a lo que hay delante engaña más que no enseñar nada: se retira la
      // etiqueta en vez de recontar con las condiciones actuales, que es justo lo que se quería
      // dejar de hacer.
      if (!consulta || typeof consulta.filter !== 'object' || !consulta.filter
          || typeof consulta.projection !== 'string') {
        self.olvidarRecuentoGestionCobro();
        return;
      }
      if (consulta.page !== 1) {
        return;
      }
      // Solo la última carga manda. Si se cambia de filtro mientras el recuento del anterior sigue
      // en el aire, la respuesta vieja llega después y pisaría el número de la carga que ya está en
      // pantalla —o lo escondería con su `catch`—, sin que nada lo delate. La generación se cuenta
      // por ORDEN DE LLEGADA de los `load`, que es el mismo orden en el que las filas se pintan:
      // por eso la etiqueta siempre corresponde a las filas que se están viendo.
      self.generacionRecuento += 1;
      const generacion = self.generacionRecuento;
      const vigente = () => generacion === self.generacionRecuento;
      self.Cliente.recuentoGestionCobro({ filter: consulta.filter, projection: consulta.projection })
        .then((recuento) => {
          if (vigente()) {
            self.recuentoGestionCobro = recuento;
          }
        })
        .catch(() => {
          // Sin recuento la consulta funciona igual: se esconde la etiqueta en vez de interrumpir
          // con un diálogo de error la pantalla que la persona venía a usar.
          if (vigente()) {
            self.recuentoGestionCobro = null;
          }
        });
    },
    mostrarFacturas(codigo) {
      const self = this;
      self.codigoClienteParaFacturas = codigo;
      self.popupListadoFacturasOpened = true;
    },
    onImport: function (res) {
      const self = this;
      var app = self.$f7;
      // Si res.documento es un array, nos quedamos con el primer elemento
      let documento = Array.isArray(res.documento) ? res.documento[0] : res.documento;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      self.Cliente.importar(documento).then((res) => {
        self.$set(self.$refs.rformImport.formData,'documento',[]);
        const codCarga = res.codCarga;
        const numeroOK = res.numeroOK;
        const numeroKO = res.numeroKO;
        // const filasKO = res.filasKO;
        const errores = res.errores;
        var message = `Importación realizada codigo <b>${codCarga}</b>: <br><ul>`;
        // if (numeroOK) {
        message += `<li style="color: blue">Importados OK: ${numeroOK}</li>`;
        // }
        if (numeroKO) {
          message += `<li style="color: red">Importados KO: ${numeroKO}</li>`;
        }
        // if (filasKO.length) {
        //   message += `<li style="color: red">Filas con fallos: ${filasKO.join()}</li>`;
        // }
        if (errores && errores.length) {
          message += `<li style="color: red">Errores: <ul>`;
          errores.forEach((err) => {
            message += `<li style="color: red">${err}</li>`;
          });
          message += `</ul></li>`;
        }
        message += `</ul>`;
        app.dialog.alert(message);
        espera.cerrar();
        // Una importación da de alta clientes, y un cliente nuevo nace SIN responsable de gestión de
        // cobro: en cuanto entra, las cifras de la etiqueta ya no corresponden a los datos. La tabla
        // no se recarga aquí —la llamada de abajo lleva comentada desde antes de esta tarea y
        // descomentarla cambiaría el comportamiento de la importación, que no es de esta tarea—, así
        // que lo que sí se puede hacer es dejar de afirmar un número que la propia persona acaba de
        // invalidar: se retira la etiqueta y vuelve con la siguiente búsqueda. Lo que NO se hace es
        // volver a pedir el recuento, que daría la cifra de después de importar junto a las filas de
        // antes: el número tiene que ser el del conjunto que se está viendo o no estar.
        //
        // Si no se dio de alta ninguno (todo KO) no se ha escrito nada y el número sigue valiendo.
        if (numeroOK !== 0) {
          self.olvidarRecuentoGestionCobro();
        }
        // self.$refs.rlist.submitFilterForm();
      }).finally(() => espera.cerrar());
    },
    onImportError: function (e) {
      var self = this;
      var app = self.$f7;
      app.preloader.hide(); 
      // TODO mensaje error;
    },
    beforeSaveImport: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var o = Object.assign({}, data);
      o.documento = Array.isArray(o.documento) ? o.documento[0] : o.documento;
      app.preloader.hide();
      resolve(o);
    },
    loadFile: function () {
      var self = this;
      var app = self.$f7;
      self.$refs.rformImport.saveItem();
      app.preloader.show();
    },
    verEnBC: function (bcId) {
      var self = this;
      var app = self.$f7;
      if (!bcId) {
        app.dialog.alert(self.$t('pedidos.bcId_no_disponible') || 'No hay bcId para este pedido.');
        return;
      }
      const baseUrl = process.env.VUE_APP_BC_WEB_URL || process.env.VUE_APP_BC_URL || '';
      if (!baseUrl) {
        app.dialog.alert('Configura VUE_APP_BC_WEB_URL para abrir el pedido en Business Central');
        return;
      }
      const environment = process.env.VUE_APP_BC_ENVIRONMENT ? `${process.env.VUE_APP_BC_ENVIRONMENT}/` : '';
      const company = process.env.VUE_APP_BC_COMPANY_ID;
      const companyParam = company ? `company=${encodeURIComponent(company)}` : '';
      const pageParam = 'page=21';
      const filterParam = `filter='$systemId' IS '${encodeURIComponent(bcId)}'`;
      const query = [companyParam, pageParam, filterParam].filter(Boolean).join('&');
      const url = `${baseUrl.replace(/\/$/, '')}/${environment}?${query}`;
      window.open(url, '_blank');
    },
    enviarBC: function (idCliente) {
      var self = this;
      var app = self.$f7;
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Cliente.enviarBC({ itemId: idCliente }).then(function (res) {
        espera.cerrar();
        app.toast
          .create({
            text: self.$t("pedidos.envio_bc_ok"),
            position: "center",
            closeTimeout: 2000,
            icon: '<i class="f7-icons">checkmark_alt</i>'
          })
          .open();
        self.$refs.rlist.reload();
      }).catch(function (error) {
        espera.cerrar();
        app.dialog.alert(error.message);
      });
    },
  },
  mounted: function() {
    var self = this;
    var app = self.$f7;
    /*app.dataTable.create({
      el: self.$refs.datatable
    });*/
  }
};
</script>
